export const TIME_UNIT = {
  YEARS: 'years',
  DAYS: 'days',
  HOURS: 'hours',
  MINUTES: 'minutes'
}
